define(['core/urls'],
    function(urls) {

        return {
            'init': function() {
                var anchor = location.hash;
                // redirection for legacy tab 'profile' (now separate page)
                if (anchor === '#profile') {location = urls['account:profile'](); return;}
                // redirection for legacy tab 'users' (now separate page)
                if (anchor === '#users') {location = urls['account:users'](); return;}
                // redirection for legacy tab 'profile' (now separate page)
                if (anchor === '#billing') {location = urls['account:billing'](); return;}
                // redirection for legacy tab 'cc' (now 'billing portal')
                if (anchor === '#cc') {location = urls['account:billing'](); return;}
                // redirection for legacy tab 'subscriptions' (now 'billing portal')
                if (anchor === '#subscriptions') {location = urls['account:billing'](); return;}
                // redirection for legacy tab 'integrations' (now separate section)
                if (anchor === '#integrations') {location = urls['integration:overview'](); return;}
                // redirection for legacy tab 'cwcred' (now separate page under integrations)
                if (anchor === '#cwcred') {location = urls['ticketsource:connectwise'](); return;}

                // more legacy pages
                if (anchor === '#company') {location = urls['account:billing'](); return;}
                if (anchor === '#password') {location = urls['account:profile'](); return;}
                if (anchor === '#subscription') {location = urls['account:billing'](); return;}
                if (anchor === '#invoices') {location = urls['account:billing'](); return;}

                // not sure how we got here, but let's just redirect the user anywhere more useful than this empty page
                location = urls['account:profile']();
            }
        };

    }
);
